import { useEffect, useRef } from "react";
import confetti from "canvas-confetti";
import { useOnboardingWizard } from "./OnboardingWizardProvider";

const NARA_COLORS = ["#F69E47", "#F8C552", "#F9D857", "#748666", "#C0CEBA"];

export function ConfettiCelebration() {
  const { pendingCelebrations } = useOnboardingWizard();
  const firedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (pendingCelebrations.length === 0) return;

    const latest = pendingCelebrations[0];
    if (firedRef.current.has(latest.achievementId)) return;
    firedRef.current.add(latest.achievementId);

    // Fire confetti burst
    const duration = 2000;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.7 },
        colors: NARA_COLORS,
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.7 },
        colors: NARA_COLORS,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
  }, [pendingCelebrations]);

  return null; // confetti renders to global canvas
}
